import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Avatar,
  Box,
  Grid,
  Divider
} from '@mui/material';
import { Phone, Email, Description } from '@mui/icons-material';
import { contactService, getPhotoUrl } from '../../services/api';

const ContactDetails = ({ open, onClose, contact }) => {
  if (!contact) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Detalhes do Contato</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Avatar
            src={contact.photo ? getPhotoUrl(contact.photo) : undefined}
            sx={{ width: 120, height: 120, mb: 2 }}
          >
            {!contact.photo && contact.name.charAt(0).toUpperCase()}
          </Avatar>
          <Typography variant="h5" gutterBottom>
            {contact.name}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary" gutterBottom>
            {contact.shortDescription}
          </Typography>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" mb={1}>
              <Phone sx={{ mr: 1 }} />
              <Typography variant="body1">
                <strong>Telefone Principal:</strong> {contact.phone1}
              </Typography>
            </Box>
          </Grid>

          {contact.phone2 && (
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" mb={1}>
                <Phone sx={{ mr: 1 }} />
                <Typography variant="body1">
                  <strong>Telefone Secundário:</strong> {contact.phone2}
                </Typography>
              </Box>
            </Grid>
          )}

          {contact.email && (
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" mb={1}>
                <Email sx={{ mr: 1 }} />
                <Typography variant="body1">
                  <strong>E-mail:</strong> {contact.email}
                </Typography>
              </Box>
            </Grid>
          )}

          <Grid item xs={12}>
            <Box display="flex" alignItems="center" mb={1}>
              <Description sx={{ mr: 1 }} />
              <Typography variant="body1">
                <strong>Configurações:</strong>
                <br />
                {contact.sendWhatsAppDiary ? '✓' : '✗'} Recebe diário via WhatsApp
                <br />
                {contact.isMainContact ? '✓' : '✗'} Contato Principal
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactDetails;
